(function(){
  if(window.__caesarLlMethodAttributionBridgeLoaded){return;}
  window.__caesarLlMethodAttributionBridgeLoaded='2026-06-22-v6';
  var VERSION='2026-06-22-v6';
  var STORAGE_KEY='ll_method_attribution_v1';
  var CART_SYNC_KEY='ll_method_cart_attr_synced_v1';
  var PARAM_KEYS=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','fbclid','gclid','ttclid','campaign_id','adset_id','ad_id','placement','ll_funnel','ll_entry_page','ll_guide_page','ll_guide_page_handle','ll_source','ll_source_page','ll_market','ll_quiz_step','quiz_persona','quiz_result_tier','quiz_score','quiz_session_id','result_tier','persona'];
  var METHOD_PATHS=['/pages/little-lifely-method','/pages/little-lifely-method-free-guide','/pages/little-lifely-method-quiz','/pages/sleep-readiness-quiz','/pages/little-lifely-method-guide','/pages/little-lifely-method-guide-book','/pages/little-lifely-method-guide-book-au-preview','/en-us/pages/little-lifely-method','/en-us/pages/little-lifely-method-free-guide-us','/en-us/pages/little-lifely-method-quiz','/en-us/pages/sleep-readiness-quiz','/en-us/pages/little-lifely-method-guide-book-us'];
  var PRODUCT_PATHS=['/products/little-lifely-bed','/en-us/products/little-lifely-bed-us'];
  function now(){try{return new Date().toISOString()}catch(e){return ''}}
  function qs(){return new URLSearchParams(location.search||'')}
  function clean(v){v=String(v==null?'':v).trim(); return v.length>240?v.slice(0,240):v}
  function safeParse(v){try{return v?JSON.parse(v):{}}catch(e){return {}}}
  function isMethodPath(path){path=path||location.pathname; return METHOD_PATHS.some(function(p){return path.indexOf(p)===0})}
  function isProductPath(path){path=path||location.pathname; return PRODUCT_PATHS.some(function(p){return path.indexOf(p)===0})}
  function readStored(){try{return safeParse(localStorage.getItem(STORAGE_KEY))}catch(e){return {}}}

  function applyKnownFunnelLabels(out){
    var path=location.pathname;
    var page=null;
    if(path.indexOf('/pages/little-lifely-method-guide-book-au-preview')===0){
      page={ll_funnel:'little_lifely_method_guide',ll_source:'method_guide',ll_market:'AU',ll_guide_page:'au_preview',ll_guide_page_handle:'little-lifely-method-guide-book-au-preview'};
    }else if(path.indexOf('/en-us/pages/little-lifely-method-quiz')===0){
      page={ll_funnel:'little_lifely_method_quiz',ll_source:'method_quiz',ll_market:'US',ll_quiz_step:'method_quiz_landing',ll_guide_page:'us_method_quiz',ll_guide_page_handle:'little-lifely-method-quiz'};
    }else if(path.indexOf('/en-us/pages/sleep-readiness-quiz')===0){
      page={ll_funnel:'little_lifely_method_quiz',ll_source:'method_quiz',ll_market:'US',ll_quiz_step:'sleep_readiness_quiz',ll_guide_page:'us_sleep_readiness_quiz',ll_guide_page_handle:'sleep-readiness-quiz'};
    }else if(path.indexOf('/pages/little-lifely-method-quiz')===0){
      page={ll_funnel:'little_lifely_method_quiz',ll_source:'method_quiz',ll_market:'AU',ll_quiz_step:'method_quiz_landing',ll_guide_page:'au_method_quiz',ll_guide_page_handle:'little-lifely-method-quiz'};
    }else if(path.indexOf('/pages/sleep-readiness-quiz')===0){
      page={ll_funnel:'little_lifely_method_quiz',ll_source:'method_quiz',ll_market:'AU',ll_quiz_step:'sleep_readiness_quiz',ll_guide_page:'au_sleep_readiness_quiz',ll_guide_page_handle:'sleep-readiness-quiz'};
    }else if(path.indexOf('/en-us/pages/little-lifely-method-free-guide-us')===0){
      page={ll_funnel:'little_lifely_method_pdf_download',ll_source:'method_pdf_download',ll_market:'US',ll_guide_page:'us_free_guide',ll_guide_page_handle:'little-lifely-method-free-guide-us'};
    }else if(path.indexOf('/en-us/pages/little-lifely-method-guide-book-us')===0){
      page={ll_funnel:'little_lifely_method_pdf_download',ll_source:'method_pdf_download',ll_market:'US',ll_guide_page:'us_guide_book',ll_guide_page_handle:'little-lifely-method-guide-book-us'};
    }else if(path.indexOf('/pages/little-lifely-method-free-guide')===0){
      page={ll_funnel:'little_lifely_method_pdf_download',ll_source:'method_pdf_download',ll_market:'AU',ll_guide_page:'au_free_guide',ll_guide_page_handle:'little-lifely-method-free-guide'};
    }else if(path.indexOf('/pages/little-lifely-method-guide-book')===0){
      page={ll_funnel:'little_lifely_method_pdf_download',ll_source:'method_pdf_download',ll_market:'AU',ll_guide_page:'au_guide_book',ll_guide_page_handle:'little-lifely-method-guide-book'};
    }
    if(page){
      Object.keys(page).forEach(function(k){out[k]=page[k];});
      out.ll_entry_page=out.ll_entry_page||path;
      out.ll_source_page=out.ll_source_page||location.href.split('#')[0];
    }
    return out;
  }
  function writeStored(data){try{localStorage.setItem(STORAGE_KEY,JSON.stringify(data)); document.cookie=STORAGE_KEY+'='+encodeURIComponent(JSON.stringify(data)).slice(0,3600)+'; path=/; max-age='+(60*60*24*30)+'; SameSite=Lax'}catch(e){}}
  function incoming(){
    var p=qs(), out={}, has=false;
    PARAM_KEYS.forEach(function(k){var v=p.get(k); if(v){out[k]=clean(v); has=true;}});
    if(isMethodPath()){has=true; out.ll_funnel=out.ll_funnel||'little_lifely_method_guide'; out.ll_source=out.ll_source||'method_guide'; out.ll_entry_page=out.ll_entry_page||location.pathname; out.ll_source_page=out.ll_source_page||location.href.split('#')[0];}
    if(has){out=applyKnownFunnelLabels(out);}
    return has?out:null;
  }
  function current(){
    var stored=readStored(), inc=incoming();
    if(inc){
      if(stored&&stored.ll_funnel==='little_lifely_method_quiz'&&(inc.ll_guide_page==='au_guide_book'||inc.ll_guide_page==='us_guide_book')){
        inc.ll_funnel='little_lifely_method_quiz';
        inc.ll_source='method_quiz';
        inc.ll_quiz_step='guide_book_after_quiz';
      }
      stored=Object.assign({},stored,inc,{ll_attribution_version:VERSION,ll_last_touch_page:location.href.split('#')[0],ll_last_seen_at:now()});
      stored.ll_first_seen_at=stored.ll_first_seen_at||now();
      writeStored(stored);
    }
    return stored;
  }
  function enrichPostHog(data){
    try{if(window.posthog){
      if(typeof posthog.get_distinct_id==='function') data.posthog_distinct_id=clean(posthog.get_distinct_id());
      if(typeof posthog.get_session_id==='function') data.posthog_session_id=clean(posthog.get_session_id());
      writeStored(data);
    }}catch(e){}
    return data;
  }
  function cartAttrs(data){
    var attrs={}; if(!data||!data.ll_funnel) return attrs;
    ['ll_funnel','ll_source','ll_entry_page','ll_guide_page','ll_guide_page_handle','ll_source_page','ll_last_touch_page','ll_attribution_version','ll_market','ll_quiz_step','quiz_persona','quiz_result_tier','quiz_score','quiz_session_id','posthog_distinct_id','posthog_session_id','utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','fbclid','campaign_id','adset_id','ad_id','placement'].forEach(function(k){if(data[k]) attrs[k]=clean(data[k]);});
    return attrs;
  }
  function syncCart(data){
    data=enrichPostHog(Object.assign({},data||current()));
    var attrs=cartAttrs(data); if(!Object.keys(attrs).length) return Promise.resolve(false);
    var fingerprint=JSON.stringify(attrs);
    try{if(sessionStorage.getItem(CART_SYNC_KEY)===fingerprint) return Promise.resolve(true);}catch(e){}
    return fetch('/cart/update.js',{method:'POST',credentials:'same-origin',keepalive:true,headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:attrs})})
      .then(function(r){if(r&&r.ok){try{sessionStorage.setItem(CART_SYNC_KEY,fingerprint)}catch(e){}; try{if(window.posthog&&posthog.capture)posthog.capture('ll funnel cart attributes synced',{ll_funnel:attrs.ll_funnel,ll_guide_page:attrs.ll_guide_page||null,ll_attribution_version:VERSION})}catch(e){}; return true} return false})
      .catch(function(){return false});
  }
  function appendParamsToProductLinks(data){
    if(!data||!data.ll_funnel) return;
    var attrs=cartAttrs(data);
    document.querySelectorAll('a[href]').forEach(function(a){
      try{var u=new URL(a.getAttribute('href'),location.origin); if(!isProductPath(u.pathname)) return; Object.keys(attrs).forEach(function(k){if(!u.searchParams.has(k))u.searchParams.set(k,attrs[k]);}); a.setAttribute('href',u.pathname+u.search+u.hash);}catch(e){}
    });
  }

  /* CAESAR_LL_METHOD_LINE_ITEM_PROPS_V2: hidden Shopify line-item metadata for checkout pixel attribution */
  function lineItemProps(data){
    var attrs=cartAttrs(data), out={};
    Object.keys(attrs).forEach(function(k){out['_'+k]=attrs[k];});
    return out;
  }
  function setHidden(form,name,value){
    if(!form||!name||!value) return;
    var found=null;
    try{Array.prototype.slice.call(form.elements||[]).forEach(function(el){if(el&&el.name===name)found=el;});}catch(e){}
    if(!found){found=document.createElement('input'); found.type='hidden'; found.name=name; form.appendChild(found);}
    found.value=value;
  }
  function isCartAddForm(form){
    if(!form) return false;
    var action=''; try{action=String(form.getAttribute('action')||form.action||'');}catch(e){}
    return /\/cart\/add(?:\.js)?/i.test(action) || !!(form.closest&&form.closest('product-form')) || !!form.querySelector('[name="id"]');
  }
  function injectLineItemProperties(data,root){
    data=enrichPostHog(Object.assign({},data||current()));
    if(!data||!data.ll_funnel) return;
    var props=lineItemProps(data);
    var forms=[];
    try{forms=Array.prototype.slice.call((root||document).querySelectorAll('form[action*="/cart/add"], product-form form, form[action*="/cart/add.js"]'));}catch(e){}
    if(root&&root.nodeType===1&&root.tagName&&root.tagName.toLowerCase()==='form'&&forms.indexOf(root)===-1) forms.push(root);
    forms.forEach(function(form){
      if(!isCartAddForm(form)) return;
      Object.keys(props).forEach(function(k){setHidden(form,'properties['+k+']',props[k]);});
    });
  }

  function bindCtas(data){
    document.addEventListener('click',function(ev){
      var a=ev.target&&ev.target.closest&&ev.target.closest('a[href]'); if(!a) return;
      var u; try{u=new URL(a.href,location.origin)}catch(e){return}
      if(!isMethodPath(location.pathname)||!isProductPath(u.pathname)) return;
      var attrsData=current(); appendParamsToProductLinks(attrsData);
      if(ev.defaultPrevented||ev.metaKey||ev.ctrlKey||ev.shiftKey||ev.altKey||a.target==='_blank') {syncCart(attrsData); return;}
      ev.preventDefault();
      Promise.race([syncCart(attrsData),new Promise(function(res){setTimeout(res,650)})]).then(function(){location.href=a.href});
    },true);
  }
  function init(){
    var data=current();
    if(data&&data.ll_funnel){appendParamsToProductLinks(data); injectLineItemProperties(data); if(isMethodPath()||isProductPath()||location.pathname.indexOf('/cart')===0) syncCart(data);}
    bindCtas(data);
    document.addEventListener('submit',function(ev){var f=ev.target&&ev.target.closest&&ev.target.closest('form'); if(isCartAddForm(f)) injectLineItemProperties(current(),f);},true);
    document.addEventListener('click',function(ev){var t=ev.target&&ev.target.closest&&ev.target.closest('button,input[type=submit],[type=submit]'); if(t){var f=t.form||(t.closest&&t.closest('form')); if(isCartAddForm(f)) injectLineItemProperties(current(),f);}},true);
    setTimeout(function(){var d=current(); if(d&&d.ll_funnel){appendParamsToProductLinks(d); injectLineItemProperties(d); syncCart(d)}},900);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();